<div fxFlex fxLayout="column" fxLayoutGap="10px">

  <div *ngIf="imageVisible" style="border: 1px dotted #ddd;border-radius: 0px;padding: 15px 10px;" fxLayout="row"
    fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxLayout="column">
      <span>Figure</span>
      <video width="350" height="300" controls>
        <source [src]="serverPath+value" onerror="this.src='assets/images/logo/no-image.png';" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
      <button [attr.guide]="'video-btn-1' + '__' + sanitizedUrl" (click)="logo()" mat-raised-button>Upload</button>
  
      <button [attr.guide]="'video-btn-2' + '__' + sanitizedUrl" *ngIf="value!=''" (click)="deleteImage(index)" mat-raised-button>delete</button>
    </div>
  </div>
  
  <div *ngIf="!imageVisible&&!imageDelete" style="border: 1px dotted #ddd;border-radius: 0px;padding: 15px 10px;" fxLayout="row"
    fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <calsoft-common-file-upload-video (fileUploadResult)=getResult($event) [type]="'home'">
    </calsoft-common-file-upload-video>
    <button [attr.guide]="'video-btn-3' + '__' + sanitizedUrl" (click)="cancelUpload()" mat-raised-button>Cancel</button>
  </div>